import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const CommissioningView = ({ customer, commissioningWork }) => {
  const getStatus = () => {
    if (customer?.status === "commissioning_complete") {
      return { label: "Complete", color: "bg-success/10 text-success" };
    }
    if (customer?.status === "commissioning_inprogress") {
      return { label: "In Progress", color: "bg-warning/10 text-warning" };
    }
    if (customer?.status === "commissioning_not_started") {
      return {
        label: "Pending",
        color:
          "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400",
      };
    }
    return { label: "Not Started", color: "bg-muted text-muted-foreground" };
  };

  const status = getStatus();

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="FlaskConical" size={20} className="text-primary" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">
          Commissioning Phase
        </h2>
        <span
          className={`ml-auto inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${status.color}`}
        >
          {status.label}
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2 p-4 rounded-lg border border-border bg-muted/30">
          <h3 className="text-sm font-semibold text-foreground mb-3">
            Serial Numbers
          </h3>
          <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 text-sm">
            <div>
              <dt className="text-muted-foreground">Panel number 1</dt>
              <dd className="font-medium text-foreground">
                {commissioningWork?.panel_number_1 || "N/A"}
              </dd>
            </div>
            <div>
              <dt className="text-muted-foreground">Panel number 2</dt>
              <dd className="font-medium text-foreground">
                {commissioningWork?.panel_number_2 || "N/A"}
              </dd>
            </div>
            <div>
              <dt className="text-muted-foreground">Panel number 3</dt>
              <dd className="font-medium text-foreground">
                {commissioningWork?.panel_number_3 || "N/A"}
              </dd>
            </div>
            <div>
              <dt className="text-muted-foreground">Panel number 4</dt>
              <dd className="font-medium text-foreground">
                {commissioningWork?.panel_number_4 || "N/A"}
              </dd>
            </div>
            <div>
              <dt className="text-muted-foreground">Inverter number</dt>
              <dd className="font-medium text-foreground">
                {commissioningWork?.inverter_number || "N/A"}
              </dd>
            </div>
          </dl>
        </div>

        <div className="p-4 rounded-lg border border-border bg-muted/30">
          <h3 className="text-sm font-semibold text-foreground mb-3">
            Voltage meter photo
          </h3>
          {commissioningWork?.voltage_meter_photo ? (
            <div className="aspect-[4/3] rounded-lg overflow-hidden bg-muted">
              <Image
                src={commissioningWork.voltage_meter_photo}
                alt="Voltage meter"
                className="w-full h-full object-contain bg-muted"
              />
            </div>
          ) : (
            <div className="aspect-[4/3] rounded-lg bg-muted flex items-center justify-center border-2 border-dashed border-border">
              <Icon name="Image" size={32} className="text-muted-foreground" />
            </div>
          )}
        </div>

        <div className="p-4 rounded-lg border border-border bg-muted/30">
          <h3 className="text-sm font-semibold text-foreground mb-3">
            Main meter serial number photo
          </h3>
          {commissioningWork?.main_meter_serial_photo ? (
            <div className="aspect-[4/3] rounded-lg overflow-hidden bg-muted">
              <Image
                src={commissioningWork.main_meter_serial_photo}
                alt="Main meter serial"
                className="w-full h-full object-contain bg-muted"
              />
            </div>
          ) : (
            <div className="aspect-[4/3] rounded-lg bg-muted flex items-center justify-center border-2 border-dashed border-border">
              <Icon name="Image" size={32} className="text-muted-foreground" />
            </div>
          )}
        </div>

        <div className="p-4 rounded-lg border border-border bg-muted/30">
          <h3 className="text-sm font-semibold text-foreground mb-3">
            Customer photo with panels (side)
          </h3>
          {commissioningWork?.customer_photo_with_panels_side ? (
            <div className="aspect-[4/3] rounded-lg overflow-hidden bg-muted">
              <Image
                src={commissioningWork.customer_photo_with_panels_side}
                alt="Customer with panels side"
                className="w-full h-full object-contain bg-muted"
              />
            </div>
          ) : (
            <div className="aspect-[4/3] rounded-lg bg-muted flex items-center justify-center border-2 border-dashed border-border">
              <Icon name="Image" size={32} className="text-muted-foreground" />
            </div>
          )}
        </div>

        <div className="p-4 rounded-lg border border-border bg-muted/30">
          <h3 className="text-sm font-semibold text-foreground mb-3">
            Customer photo with panels (front)
          </h3>
          {commissioningWork?.customer_photo_with_panels_front ? (
            <div className="aspect-[4/3] rounded-lg overflow-hidden bg-muted">
              <Image
                src={commissioningWork.customer_photo_with_panels_front}
                alt="Customer with panels front"
                className="w-full h-full object-contain bg-muted"
              />
            </div>
          ) : (
            <div className="aspect-[4/3] rounded-lg bg-muted flex items-center justify-center border-2 border-dashed border-border">
              <Icon name="Image" size={32} className="text-muted-foreground" />
            </div>
          )}
        </div>

        <div className="p-4 rounded-lg border border-border bg-muted/30">
          <h3 className="text-sm font-semibold text-foreground mb-3">
            Customer photo with inverter
          </h3>
          {commissioningWork?.customer_photo_with_inverter ? (
            <div className="aspect-[4/3] rounded-lg overflow-hidden bg-muted">
              <Image
                src={commissioningWork.customer_photo_with_inverter}
                alt="Customer with inverter"
                className="w-full h-full object-contain bg-muted"
              />
            </div>
          ) : (
            <div className="aspect-[4/3] rounded-lg bg-muted flex items-center justify-center border-2 border-dashed border-border">
              <Icon name="Image" size={32} className="text-muted-foreground" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommissioningView;
